//
//  BenefitsDocuments Actions
//  CXA Apollo
//
//  Created on 16/12/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//

import api from "../api/flexapi";

/*
Specify any custom actions in a format:
export const benefitsDocumentsActionName = "benefitsDocumentsActionName";
*/

// Type of action being performed
export const BENEFITS_DOCUMENTS_LOAD_BEGIN = "BENEFITS_DOCUMENTS_LOAD_BEGIN";
export const BENEFITS_DOCUMENTS_LOAD_SUCCESS =
  "BENEFITS_DOCUMENTS_LOAD_SUCCESS";
export const BENEFITS_DOCUMENTS_LOAD_FAILED = "BENEFITS_DOCUMENTS_LOAD_FAILED";

export function fetchDocuments(type) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: BENEFITS_DOCUMENTS_LOAD_BEGIN, payload: null });

    api
      .getDocuments(type)
      .then(response =>
        dispatch({
          type: BENEFITS_DOCUMENTS_LOAD_SUCCESS,
          payload: response.body,
        })
      )
      .catch(err =>
        dispatch({
          type: BENEFITS_DOCUMENTS_LOAD_FAILED,
          payload: err.response ? err.response.body : err,
        })
      );
  };
}



// WEBPACK FOOTER //
// ./actions/documentsActions.jsx